<template>
    <div>
        <TopTenRedeemChart></TopTenRedeemChart>
        <SpendingTotalPeriodChart></SpendingTotalPeriodChart>
        <TransactionPerDayChart></TransactionPerDayChart>
        <AverageSpendingPerHeadChart></AverageSpendingPerHeadChart>
        <AverageSpendingPerTicketChart></AverageSpendingPerTicketChart>
    </div>

</template>

<script>
import SpendingTotalPeriod from './SpendingTotalPeriod';
import TransactionPerDay from './TransactionPerDay';
import AverageSpendingPerHead from './AverageSpendingPerHead';
import AverageSpendingPerTicket from './AverageSpendingPerTicket';
import TopTenRedeem from './TopTenRedeem';

export default {
  components: {
    'SpendingTotalPeriodChart': SpendingTotalPeriod,
    'TransactionPerDayChart': TransactionPerDay,
    'AverageSpendingPerHeadChart': AverageSpendingPerHead,
    'AverageSpendingPerTicketChart': AverageSpendingPerTicket,
    'TopTenRedeemChart': TopTenRedeem
  },
  data () {
    return {};
  }
};
</script>
